import React from 'react';

import { PocketbookListItem } from '@/components/pocketbook';

import type { Carrier } from './types';

interface CarrierListItemProps {
  carrier: Carrier;
  isSelected: boolean;
}

/**
 * Carrier-specific wrapper around PocketbookListItem
 * Shows carrier name and first alias
 */
export const CarrierListItem: React.FC<CarrierListItemProps> = ({
  carrier,
  isSelected,
}) => {
  return (
    <PocketbookListItem
      label={carrier.name}
      subtitle={carrier.aliases?.[0]}
      isSelected={isSelected}
    />
  );
};
